module.exports = __webpack_public_path__ + "img/wordpress-brands.56186866.svg";